export class PMOTeamMemberModel {
    constructor() {
        this.teamId = "";
        this.employeeName = "";
        this.employeeId = "";
        this.startDateAsString = "";
        this.endDateAsString = "";
        this.dateOfJoinAsString = "";
        this.clientProvidedEmail = "";
        this.engagementComments = "";
        this.isActiveUser = true;
        this.hasTeamLeadPrivilege = false;
        this.isEnded = false;
    }
}
export default class PMOTeamMember extends PMOTeamMemberModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
